import { Injectable } from '@angular/core';
import { Auth } from '@aws-amplify/auth';
import { AuthService } from '../auth/auth.service';
import { CommonUtil } from '../util/common-util';

export interface SurveyQuestion {id:string;title:string;type:string;policy:string;options:string[];}
export interface SurveySettings {
  correctionBlockedReason?:string;correctionPending?:boolean;
  reportSync?:{state:string};eventId:number;title:string;categoryId:number;questions:SurveyQuestion[];targetSource:string;
  anonymity:string;responseUnit:string;proxyPolicy:string;options:{targetCount:number|null;startMode?:'manual'|'event_start'|'session_start_30'};
  scheduleKind?:'fixed'|'period';openingSessions?:{id:string;startAt:string;opensAt:string;isOpen:boolean}[];
  opensAt:string;closesAt:string;status:string;revision:number;publicUrl?:string;
  releaseControl?:{canWrite:boolean;message:string};
}
@Injectable({providedIn:'root'})
export class EventSurveyApiService {
  constructor(private common:CommonUtil,private auth:AuthService){}
  async admin<T=any>(id:number,action:string,body:Record<string,unknown>={}):Promise<T>{
    const options:any=this.auth.createApiHeader(await Auth.currentSession());options.body={...body,id,action};
    const response:any=await this.common.apiPost('/myevent/survey',options);return response.data;
  }
  async public<T=any>(token:string,action:string,body:Record<string,unknown>={},authenticated=false):Promise<T>{
    const options:any=authenticated?this.auth.createApiHeader(await Auth.currentSession()):this.auth.createApiHeaderBeforeLogin();
    options.body={...body,token,action};const response:any=await this.common.apiPost('/public/event-survey',options);return response.data;
  }
}
